// =====================================================================
// tournee.js — règles pures de la tournée par vérification (23-10-2026)
// =====================================================================
// Demande de Silviu : une ou plusieurs personnes par vérification, et « les
// personnes déjà attribuées aux vérifications précédentes ne doivent plus
// apparaître ». Le serveur refuse aussi le doublon (safety-tournee.service.js) :
// l'écran ne propose simplement jamais la combinaison impossible.
// =====================================================================

/** Fréquences proposées (en semaines) et leur libellé — les mêmes que le serveur. */
export const FREQUENCES = [
  [1, 'chaque semaine'],
  [2, 'toutes les 2 semaines'],
  [4, 'toutes les 4 semaines'],
  [13, 'tous les 3 mois'],
  [26, 'tous les 6 mois'],
  [52, 'une fois par an'],
];
export const libelleFrequence = (n) => (FREQUENCES.find(([v]) => v === Number(n)) || [null, `toutes les ${n} semaines`])[1];

/**
 * Les personnes libres, qu'on peut encore ajouter à n'importe quelle vérification :
 * ni en congé ce jour-là, ni déjà placées (sur celle-ci ou une autre).
 * `repartition` = { itemId: [userId, …] }.
 */
export function personnesLibres(personnes, repartition) {
  const placees = new Set(Object.values(repartition || {}).flat());
  return (personnes || []).filter((p) => !p.conge && !placees.has(p.id));
}

/** Une vérification se règle avec un projet ET une tâche, ou aucun des deux. */
export function erreurProcedure(item, autres = []) {
  const label = String(item.label ?? '').trim();
  if (label.length < 3) return 'Le libellé fait au moins 3 caractères.';
  if (autres.some((a) => a.id !== item.id && String(a.label).trim().toLowerCase() === label.toLowerCase())) {
    return `Une vérification « ${label} » existe déjà dans cette procédure.`;
  }
  if (!FREQUENCES.some(([v]) => v === Number(item.periodicityWeeks))) return 'Choisissez une fréquence.';
  if (Boolean(item.projectId) !== Boolean(item.taskId)) return 'Choisissez le projet ET la tâche où va le temps (ou aucun des deux).';
  const m = item.standardMinutes;
  if (m !== null && m !== undefined && m !== '' && !(Number.isInteger(Number(m)) && Number(m) >= 1 && Number(m) <= 240)) {
    return 'La durée habituelle est un nombre de minutes entre 1 et 240.';
  }
  return null;
}

/** « 12 min », « 1 h 05 » */
export function duree(min) {
  if (min === null || min === undefined) return '—';
  const m = Math.round(Number(min));
  if (m < 60) return `${m} min`;
  return `${Math.floor(m / 60)} h ${String(m % 60).padStart(2, '0')}`;
}
